import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { LOCALES, type Locale } from '@/lib/i18n';
import { Button } from '@/components/ui/button';

/** One switch flips strings, `dir` and the font, everywhere at once. */
export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const next: Locale = i18n.language.startsWith('ar') ? 'en' : 'ar';

  return (
    <Button
      variant="ghost"
      size="sm"
      className="h-[30px] gap-1.5 px-2 text-xs"
      onClick={() => void i18n.changeLanguage(next)}
      title={LOCALES[next].nativeName}
    >
      <Languages className="h-3.5 w-3.5" aria-hidden />
      <span>{LOCALES[next].nativeName}</span>
    </Button>
  );
}
